import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import styles from './Stepper.module.css';
import backIcon from '../../../../assets/icons/gardenwall/right-arrow.svg';

const Stepper = ({ steps = [], workflowId }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (path) {
      const dynamicPath = path.includes('${workflowId}')
        ? path.replace('${workflowId}', workflowId)
        : path;
      navigate(dynamicPath, { state: { workflowId: workflowId } });
    }
  };

  return (
    <>
      <div className={styles.stepper}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div
              className={`${styles.step} ${step.active ? styles.active : ''}`}
              onClick={() => handleClick(step.path)}
            >
              {step.label === 'Home' ? (
                <Home className={styles.homeIcon} size={20} />
              ) : (
                <span>{step.label}</span>
              )}
            </div>

            {index < steps.length - 1 && (
              <span className={styles.arrow}> / </span>
            )}
          </React.Fragment>
        ))}
      </div>
      <div
        className={styles.backButton}
        onClick={() =>
          navigate(`/workflow/${workflowId}`, {
            state: {
              workflowId: workflowId,
            },
          })
        }
      >
        <img src={backIcon} alt="back-icon" className={styles.icon} />
        <span>Back</span>
      </div>
    </>
  );
};

export default Stepper;
